import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonMenuButton,
  IonPage,
  IonPopover,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTextarea,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useCallback, useEffect, useMemo, useState } from "react";
import Calendar from "react-calendar";

import "./SchedulingForm.css";

import moment from "moment-timezone";
import _ from "underscore";
import { chevronBack, chevronForward } from "ionicons/icons";
import SchedulingHourButton from "../SchedulingHourButton/SchedulingHourButton";
import API from "../../../lib/API";
import WindowUtils from "../../../lib/WindowUtils";
import Event from "../../../lib/Event";
import PubSub from "../../../lib/PubSub";
import StringUtils from "../../../lib/StringUtils";

const SchedulingForm: React.FC<{
  appointmentType?: any;
  onChange?: any;
  value?: any;
  fields?: any;
  title?: any;
  requiredFields?: any;
  bgWhite?: boolean;
  initialValue?: any;
}> = ({
  appointmentType = null,
  onChange = null,
  value = null,
  fields = [],
  requiredFields = [],
  title = "Enter Your Information Below",
  bgWhite = false,
  initialValue = null,
}) => {
  const [email, setEmail] = useState<any>("");
  const [notes, setNotes] = useState<any>("");
  const [name, setName] = useState<any>("");
  const [goal, setGoal] = useState<any>("");
  const [phone, setPhone] = useState("");
  const [phoneReadable, setPhoneReadable] = useState("");

  useEffect(() => {
    let vals: any = {
      phone: phone,
      email: email,
      notes: notes,
      name: name,
      goal: goal,
    };

    //console.log(vals); //debug

    if (typeof onChange == "function") {
      try {
        if (JSON.stringify(value) == JSON.stringify(vals)) {
          return;
        }
      } catch (e) {}

      onChange(vals);
    }
  }, [name, email, phone, goal, notes, onChange, value]);

  useEffect(() => {
    // console.log(initialValue);

    if (!initialValue) {
      return;
    }

    if (initialValue?.phone) {
      const res = StringUtils.formatPhoneNumberWhileTyping(initialValue?.phone);

      setPhone(initialValue?.phone);
      setPhoneReadable(res?.formatted);
    }

    if (initialValue?.email) {
      setEmail(initialValue?.email);
    }

    if (initialValue?.name) {
      setName(initialValue?.name);
    }

    if (initialValue?.goal) {
      setGoal(initialValue?.goal);
    }

    if (initialValue?.notes) {
      setNotes(initialValue?.notes);
    }
  }, [initialValue]);

  return (
    <>
      <div
        style={{
          borderRadius: 6,
          border: "1px solid var(--midlighter)",
        }}
        className={`p-3 ${bgWhite && "bg-white"}`}
      >
        <h4 className="text-dark mt-0 mb-3 text-center">{title}</h4>

        {fields?.includes("name") ? (
          <>
            <div>
              <div className="relative">
                <label
                  htmlFor="name"
                  className="absolute rounded-sm -top-[9px] left-2 inline-block bg-white px-1.5 text-[13px] font-medium text-gray-800 focus:text-orange-500"
                >
                  Name
                  {requiredFields?.includes("name") && (
                    <span className="text-red-600 ml-[2px]">*</span>
                  )}
                </label>
                <input
                  type="text"
                  name="name"
                  autoComplete="name"
                  value={name}
                  required={requiredFields?.includes("name")}
                  className="block w-full text-base sm:text-lg rounded outline-0 border border-gray-100 px-3 py-[0.7rem] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 transition-all focus:ring-2 focus:ring-inset focus:ring-orange-500 sm:leading-6"
                  placeholder="Your Name"
                  onChange={(event: any) => {
                    setName(event?.target?.value);
                  }}
                />
              </div>
            </div>
          </>
        ) : null}
        {fields?.includes("email") ? (
          <div className={fields?.includes("name") ? "mt-4" : ""}>
            <div className="relative">
              <label
                htmlFor="email"
                className="absolute rounded-sm -top-[9px] left-2 inline-block bg-white px-1.5 text-[13px] font-medium text-gray-800 focus:text-orange-500"
              >
                Email
                {requiredFields?.includes("email") && (
                  <span className="text-red-600 ml-[2px]">*</span>
                )}
              </label>
              <input
                type="email"
                name="email"
                autoComplete="email"
                value={email}
                required={requiredFields?.includes("email")}
                className="block w-full text-base sm:text-lg rounded outline-0 border border-gray-100 px-3 py-[0.7rem] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 transition-all focus:ring-2 focus:ring-inset focus:ring-orange-500 sm:leading-6"
                placeholder="hello@projectleannation.com"
                onChange={(event) => {
                  setEmail(event?.target?.value);
                }}
              />
            </div>
          </div>
        ) : null}
        {fields?.includes("phone") ? (
          <div
            className={
              fields?.includes("email") || fields?.includes("name")
                ? "mt-4"
                : ""
            }
          >
            <div className="relative">
              <label
                htmlFor="phone"
                className="absolute rounded-sm -top-[9px] left-2 inline-block bg-white px-1.5 text-[13px] font-medium text-gray-800 focus:text-orange-500"
              >
                Phone
                {requiredFields?.includes("phone") && (
                  <span className="text-red-600 ml-[2px]">*</span>
                )}
              </label>
              <input
                type="text"
                name="phone"
                id="phone"
                value={phoneReadable}
                required={requiredFields?.includes("phone")}
                autoComplete="tel"
                className="block w-full text-base sm:text-lg rounded outline-0 border border-gray-100 px-3 py-[0.7rem] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 transition-all focus:ring-2 focus:ring-inset focus:ring-orange-500 sm:leading-6"
                placeholder="+1 (908) 867-5309"
                onChange={(event: any) => {
                  let result = StringUtils.formatPhoneNumberWhileTyping(
                    event?.target?.value,
                  );

                  setPhone(result?.value);
                  setPhoneReadable(result?.formatted);
                }}
              />
            </div>
          </div>
        ) : null}
        {fields?.includes("goal") ? (
          <>
            <div
              className={
                fields?.includes("email") ||
                fields?.includes("name") ||
                fields?.includes("phone")
                  ? "mt-4"
                  : ""
              }
            >
              <div className="relative">
                <label
                  htmlFor="phone"
                  className="absolute rounded-sm -top-[9px] left-2 inline-block bg-white px-1.5 text-[13px] font-medium text-gray-800 focus:text-orange-500"
                >
                  What Goal Can We Help You Achieve?
                  {requiredFields?.includes("goal") && (
                    <span className="text-red-600 ml-[2px]">*</span>
                  )}
                </label>
                <select
                  name="goal"
                  value={goal}
                  required={requiredFields?.includes("goal")}
                  className="block w-full text-base sm:text-lg rounded outline-0 border border-gray-100 px-3 py-[0.7rem] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 transition-all focus:ring-2 focus:ring-inset focus:ring-orange-500 sm:leading-6"
                  onChange={(event) => {
                    setGoal(event?.target?.value);
                  }}
                >
                  <option disabled value="">
                    Select Goal
                  </option>
                  <option value="Weight Management">Weight Management</option>
                  <option value="Muscle Gain">Muscle Gain</option>
                  <option value="Convenience">Convenience</option>
                  <option value="Optimize Health">Optimize Health</option>
                  <option value="Referred by Physician">
                    Referred by Physician
                  </option>
                  <option value="Other Goals">Other Goals</option>
                </select>
              </div>
            </div>
          </>
        ) : null}
        {fields?.includes("notes") ? (
          <>
            <div
              className={
                fields?.includes("goal") ||
                fields?.includes("phone") ||
                fields?.includes("email") ||
                fields?.includes("name")
                  ? "mt-4"
                  : ""
              }
            >
              <div className="relative">
                <label
                  htmlFor="name"
                  className="absolute rounded-sm -top-[9px] left-2 inline-block bg-white px-1.5 text-[13px] font-medium text-gray-800 focus:text-orange-500 z-10"
                >
                  Anything Else You'd Like To Share?
                  {requiredFields?.includes("notes") && (
                    <span className="text-red-600 ml-[2px]">*</span>
                  )}
                </label>
                <textarea
                  rows={3}
                  name="notes"
                  autoComplete="notes"
                  value={notes}
                  required={requiredFields?.includes("notes")}
                  className="block w-full text-base sm:text-lg rounded outline-0 border border-gray-100 px-3 py-[0.7rem] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 transition-all focus:ring-2 focus:ring-inset focus:ring-orange-500 sm:leading-6"
                  placeholder="Comments"
                  onChange={(event: any) => {
                    setNotes(event?.target?.value);
                  }}
                />
              </div>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default SchedulingForm;
